<template>
    <div class="digital-classrooms">
        <p v-html="$t('GoLearn.digital_classrooms_button')" @click="goLearnDigitalClassrooms" class="digital-classrooms__link"></p>
        <span class="icon-arrow-right"></span>
    </div>
</template>

<script>
    export default {
        name: 'digital-classrooms-link',
        methods: {
            goLearnDigitalClassrooms () {
                window.open('https://www.golearn.dk/classroom/', '_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .digital-classrooms {
        display: flex;
        color: $lavender;

        &__link {
            text-decoration: underline;
            position: relative;
            cursor: pointer;
            display: flex;
            align-items: center;
            font-family: PlusJakartaSans-Bold, sans-serif;

            &:hover {
                text-decoration: none;
            }
        }

        .icon-arrow-right {
            font-size: 2rem;
            transform: rotate(-45deg);
            margin-left: 3px;
        }
    }
</style>
